// Generated types for StepTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { LLMTaskReadAPI, LLMTaskWriteAPI } from './llmtask';
import { LLMTaskReadAPISchemaObject, LLMTaskWriteAPISchemaObject } from './llmtask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface StepTaskReadAPI extends LLMTaskReadAPI {
}

export interface StepTaskWriteAPI extends LLMTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const StepTaskReadAPISchemaObject = LLMTaskReadAPISchemaObject.extend({}).passthrough();
export const StepTaskReadAPISchema: z.ZodType<StepTaskReadAPI> = StepTaskReadAPISchemaObject;

export const StepTaskWriteAPISchemaObject = LLMTaskWriteAPISchemaObject.extend({}).passthrough();
export const StepTaskWriteAPISchema: z.ZodType<StepTaskWriteAPI> = StepTaskWriteAPISchemaObject;
